/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".kt-widget14[_ngcontent-%COMP%]{padding:0}\n/*# sourceMappingURL=widget-profit-share.component.css.map*/"];
export { styles as styles };
